module.exports = __webpack_public_path__ + "static/img/perfectLogo.5d8c8ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/perfectLogo.png
// module id = 828
// module chunks = 2